import { AlertTriangle } from 'lucide-react';

export default function DeleteDocumentModal({ document, onCancel, onConfirm, deleting }) {
  if (!document) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#00384D]/50 backdrop-blur-[2px] px-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-sm px-6 py-6 border border-slate-200">
        <div className="h-10 w-10 rounded-full bg-[#C21E26]/8 flex items-center justify-center mb-4">
          <AlertTriangle className="h-5 w-5 text-[#C21E26]" strokeWidth={1.75} />
        </div>
        <h2 className="text-[#00384D] font-semibold text-base">Delete Document?</h2>
        <p className="text-sm text-slate-500 mt-2 leading-relaxed">
          Are you sure you want to permanently delete{' '}
          <span className="font-medium text-[#00384D]">"{document.title}"</span>? This action
          cannot be undone.
        </p>
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-slate-500 hover:text-[#00384D] transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={deleting}
            className="bg-[#C21E26] text-white text-sm font-medium rounded-md px-5 py-2 hover:bg-[#A61820] transition-colors disabled:opacity-50"
          >
            {deleting ? 'Deleting…' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}
